import React, { useState } from 'react'
import { observer } from 'mobx-react'
import Input from '@material-ui/core/Input'
import Button from '@material-ui/core/Button'
import './Login.css'
import useStore from '../../hooks/useStore'
import { useHistory } from 'react-router-dom'
import axios from '../../axios'
import { Alert } from '@material-ui/lab'

export const Login = observer(() => {
  const history = useHistory()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const store = useStore()

  const signIn = async (ev) => {
    const Data = {setEmail: email, setPassword: password}
    axios.post('/login.json', Data).then(res => {
      console.log(res)
    })
    try {
      ev.preventDefault()
      await store.signInWithEmailAndPassword(email, password)
      history.push('/profile')
    } catch (err) {
      alert(err)
    }
  }

  const signOut = async (ev) => {
    try {
      ev.preventDefault()
      await store.signOut()
    } catch (err) {
      alert(err)
    }
  }

  const register = async (ev) => {
    const Data = {setEmail: email, setPasswor: password}
    axios.post('/register.json', Data).then(res => {
      console.log(res)
    })
    try {
      ev.preventDefault()
      await store.register({ email, password }) 
      alert('Account created. Please SIGN IN to continue')
      history.push('/')
    } catch (err) {
      alert(err)
    }
  }

  if (store.loading) {
    return 'one moment pleaseeeee....'
  }

  return (
    <>
      <div className='login'>
        <h1>Bloom Hope.</h1>
        <h3>Please Sign in or Create Account</h3>
        <div className='login__container'>
          <form className='login__form'>
            <Input
              placeholder='Email'
              type='email'
              value={email}
              onChange={(evt) => setEmail(evt.target.value)}
              inputProps={{ 'aria-label': 'description' }}
            />
            <br />

            <Input
              placeholder='Password'
              type='password'
              value={password}
              onChange={(evt) => setPassword(evt.target.value)}
              inputProps={{ 'aria-label': 'description' }}
            />
            <br />

            <Button type='submit' onClick={signIn}>
              Sign In
            </Button>
            <Button type='submit' onClick={register}>
              Register
            </Button>
            <Button type='submit' onClick={signOut}>
              Log out
            </Button>
            <br />
          </form>
        </div>
      </div>
    </>
  )
})

// const noop = () => {}
